/* import __COLOCATED_TEMPLATE__ from './connect.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';
import type SalesforceConfiguration from 'embercom/models/standalone/salesforce-configuration';

interface Signature {
  Args: {
    onNext?: () => void;
    openSection: string | null;
    setSection?: (section: string | null) => void;
    errorCode?: string;
  };
}

export default class ConnectComponent extends Component<Signature> {
  @service declare appService: AppService;
  @service declare finStandaloneService: FinStandaloneService;
  @service declare notificationsService: $TSFixMe;
  @service declare intl: IntlService;

  constructor(owner: any, args: Signature['Args']) {
    super(owner, args);

    this.handleErrorCode();
  }

  @action
  setSection(section: string | null) {
    this.args.setSection?.(section);
  }

  @action
  formatSalesforceLabel(config: SalesforceConfiguration): string {
    return `${config.environmentLabel} - ${config.domain}`;
  }

  get openSection() {
    if (
      this.finStandaloneService.salesforcePlatform.salesforceConfig?.isConnected ||
      this.args.openSection === 'connect'
    ) {
      return this.args.openSection;
    }

    return null;
  }

  private handleErrorCode() {
    if (!this.args.errorCode) {
      return;
    }
    this.notificationsService.notifyError(this.errorMessage);
  }

  private get errorMessage() {
    switch (this.args.errorCode) {
      case 'OAUTH_APP_BLOCKED':
        return this.intl.t(
          'standalone.salesforce.setup.manage-connection.errors.oauth-app-blocked',
          { htmlSafe: true },
        );
      case 'API_CURRENTLY_DISABLED':
      case 'API_DISABLED_FOR_ORG':
        return this.intl.t('standalone.salesforce.setup.manage-connection.errors.api-disabled');
      case 'unauthorized_client':
      case 'invalid_client':
        return this.intl.t('standalone.salesforce.setup.manage-connection.errors.bad-client');
      default:
        return this.intl.t('standalone.salesforce.setup.manage-connection.errors.generic');
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Cases::Connect': typeof ConnectComponent;
  }
}
